let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ijPpX")).then(() => parcelRequire('bEmjJ'));